export const ShippingTypeEnum = {
    Email: 1,
    Letter: 2,
    Box: 3,
}
